module.exports = __webpack_public_path__ + "static/media/bg2.62de9410.png";